import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'df-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Get the full URL path
    const fullPath = this.route.snapshot.url.map(segment => segment.path).join('/');

    // Extract everything after '/i/'
    const pathAfterIPrefix = fullPath.replace(/^i\//, '');

    // Get query parameters
    const queryParams = this.route.snapshot.queryParams;

    // Navigate to the path without '/i/' prefix, preserving query parameters
    this.router.navigate([pathAfterIPrefix], { queryParams });
  }
}
